// extracted by mini-css-extract-plugin
module.exports = {"hyperlink":"r0S6t"};